import React from "react";
import { icons } from "../assets/icons";

const useIcons = () => {
  const getIcon = (name, props = {}) => {
    const IconComponent = icons[name];

    if (!IconComponent) return null;

    return <IconComponent {...props} />;
  };

  const getIconComponent = (name) => {
    return icons[name] || null;
  };

  const withIcon = (config) => {
    return {
      ...config,
      icon: getIcon(config.iconName),
    };
  };

  const withIcons = (configs) => {
    return configs.map(withIcon);
  };

  return { getIcon, getIconComponent, withIcon, withIcons };
};

export default useIcons;
